import { apiClient } from './client.js';
import type { TenantSettings, UpdateTenantSettingsInput } from '@atomfit/shared';

export interface StripeConnectStatus {
  migrationRequired: boolean;
  replacementAccountId: string | null;
  feePayer: string | null;
  connected: boolean;
  stripeAccountId: string | null;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
  onboardingComplete: boolean;
  requirementsDue: string[];
  disabledReason: string | null;
}

export const settingsApi = {
  get: () => apiClient.get<TenantSettings>('/owner/settings'),

  update: (data: UpdateTenantSettingsInput) =>
    apiClient.put<TenantSettings>('/owner/settings', data),

  stripeStatus: () =>
    apiClient.get<StripeConnectStatus>('/owner/stripe-connect/status'),

  stripeAccountLink: () =>
    apiClient.post<{ url: string; stripeAccountId: string }>('/owner/stripe-connect/account-link'),
};
